import React, { useState } from 'react'
import { Dropdown } from '../../../helpers/components/Dropdown'
import ReactModal from 'react-modal'
import CustomisationInstaModal from './CustomizationInstaModal'
import AddInstaIntentModal from './AddInstaIntentModal'
import DeleteInstaIntentModal from './DeleteInstaIntentModal'

interface Props {
  addIntentDropdownMenuRef: any
  index: number
  intent: any
  inputJson: any[]
  setInputJson: React.Dispatch<React.SetStateAction<any[]>>
  newIntentId: any
  setNewIntentId: any
  data: any
}

const IntentDropdownMenu: React.FC<Props> = ({
  addIntentDropdownMenuRef,
  index,
  intent,
  inputJson,
  setInputJson,
  newIntentId,
  setNewIntentId,
  data
}) => {
  const [isIntentDropdown, setIsIntentDropdown] = useState<boolean>(false)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [isIntentModalOpen, setIsIntentModalOpen] = useState<boolean>(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false)

  const closeDropdown = () => {
    setIsIntentDropdown(false)
  }

  const openModal = () => {
    setIsModalOpen(true)
  }

  const afterOpenModal = () => {
    // subtitle.style.color = '#f00'
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const openIntentModal = () => {
    setIsIntentModalOpen(true)
    // setIsDropdownOpen(false)
  }

  const afterIntentOpenModal = () => {
    // subtitle.style.color = '#f00'
  }

  const closeIntentModal = () => {
    setIsIntentModalOpen(false)
  }

  const openDeleteModal = () => {
    setIsDeleteModalOpen(true)
  }

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false)
  }

  const afterIntentModal = () => {
    // subtitle.style.color = '#f00'
  }

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-15%, -45%)',
      border: '2px solid #dde',
      overflow: 'scroll'
    }
  }

  const AddModalStyles = {
    content: {
      top: '40%',
      left: '40%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-15%, -45%)',
      border: '2px solid #dde'
    }
  }

  const DeleteModalStyles = {
    content: {
      top: '40%',
      left: '40%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-15%, -45%)',
      border: '2px solid #dde'
    }
  }
  return (
    <>
      <button
        className={`btn btn-sm btn-icon btn-active-light-primary`}
        onClick={() => {
          setIsIntentDropdown(!isIntentDropdown)
        }}
      >
        <i className='bi bi-three-dots-vertical text-info fs-3' />
      </button>
      <Dropdown
        menuRef={addIntentDropdownMenuRef}
        droppedDown={isIntentDropdown}
        setDroppedDown={setIsIntentDropdown}
        styles={{ marginRight: '-8rem' }}
      >
        <div className='py-1 px-4'>
          <p
            className='link-primary hoverable text-start'
            role='button'
            onClick={() => {
              openModal()
              closeDropdown()
            }}
          >
            <i className='bi bi-pencil-square link-primary fs-4 me-1'></i>
            <span className='edit'>Edit</span>
          </p>
          <ReactModal
            isOpen={isModalOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customModalStyles}
            // contentLabel='Edit User'
          >
            <CustomisationInstaModal
              intent={intent}
              closeModal={closeModal}
              inputJson={inputJson}
              setInputJson={setInputJson}
              data={data}
            />
          </ReactModal>
          <p
            className='link-primary hoverable text-start'
            role='button'
            /*onClick={()=>deleteIntent(intent,inputJson,setInputJson,closeDropdown )}*/
            onClick={() => {
              openDeleteModal()
              closeDropdown()
            }}
          >
            <i className='bi bi-trash text-danger fs-4 me-1' />
            <span className=''>Delete</span>
          </p>
          <ReactModal
            isOpen={isDeleteModalOpen}
            onAfterOpen={afterIntentModal}
            onRequestClose={closeDeleteModal}
            style={DeleteModalStyles}
            // contentLabel='Edit User'
          >
            <DeleteInstaIntentModal
              intent={intent}
              closeModal={closeDeleteModal}
              inputJson={inputJson}
              setInputJson={setInputJson}
              data={data}
            />
          </ReactModal>

          <p
            className='link-primary hoverable mb-n1'
            role='button'
            onClick={() => {
              openIntentModal()
              closeDropdown()
            }}
          >
            <i className='bi bi-plus text-primary fs-4 me-1' />
            <span className=''>Add Intent</span>
          </p>
          <ReactModal
            isOpen={isIntentModalOpen}
            onAfterOpen={afterIntentOpenModal}
            onRequestClose={closeModal}
            style={AddModalStyles}
            // contentLabel='Add User'
          >
            <AddInstaIntentModal
              intent={intent}
              closeModal={closeIntentModal}
              inputJson={inputJson}
              setInputJson={setInputJson}
              newIntentId={newIntentId}
              setNewIntentId={setNewIntentId}
            />
          </ReactModal>
        </div>
      </Dropdown>
    </>
  )
}

export default IntentDropdownMenu
